export function isEUAwsRegion(awsRegion: string | null | undefined) {
  return !!awsRegion?.startsWith("eu-");
}
